module.exports = "https://staticsandbox.coteibem.com.br/assets/increasing-laptop.b44599caad0738d3d148f2ceb1249105.svg";